import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../shared/mutators";

export type NavigationSurface =
  | "sidebar"
  | "top_bar"
  | "profile_menu"
  | "space_menu"
  | "personal_menu"
  | "chat_menu"
  | "workflow_menu";

export function useRecordNavigationClick() {
  const z = useZero();
  return (surface: NavigationSurface, destination: string) =>
    z.mutate(sharedMutators.recordNavigationClick({ surface, destination }));
}
